import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "component-wrapper",
  id: "application-detail"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  class: "application-summary-wrapper",
  style: {}
}
const _hoisted_4 = { class: "application-summary section-1" }
const _hoisted_5 = { class: "summary-items" }
const _hoisted_6 = { class: "summary-item r1" }
const _hoisted_7 = { class: "cu-program-container" }
const _hoisted_8 = { class: "cu-program-name" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "product-abbreviation" }
const _hoisted_11 = { class: "summary-item r1" }
const _hoisted_12 = { class: "school-container" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "application-summary section-2" }
const _hoisted_17 = { class: "summary-items" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "content" }

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import DetailsStepper from "@/components/v2/application/DetailsStepper.vue";
import DetailsHeaderPEL from "@/components/v2/application/details/DetailsHeaderPEL.vue";
import ApplicationStatusContainer from "@/components/v2/application/ApplicationStatusContainer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsPEL',
  setup(__props) {

const applicationStore = useApplicationStore();

const { summary } = storeToRefs(applicationStore);

const lenderName = computed<string>(
  () => applicationStore.application?.detailViewModel.lenderName || ""
);

const productAbbreviation = computed<string>(() =>
  summary.value.lenderName.split("-")[1].trim()
);

const maxLoanAmount = computed(
  () => applicationStore.summary.maxApprovedLimitDisplay
);

const summaryFields = computed(() => {
  return [
    {
      title: "Loan Amount",
      value: summary.value.loanAmountDisplay,
    },
    {
      title: "Max Approved",
      value: maxLoanAmount.value,
    },
    {
      title: "Interest Rate",
      value: `${summary.value.rate} / ${summary.value.rateTypeName}`,
    },
    {
      title: "Anticipated Grad Date",
      value: `${summary.value.graduationDate}`,
    },
    {
      title: "Requested Term",
      value: `${summary.value.academicTerm}`,
    },
  ];
});

return (_ctx: any,_cache: any) => {
  const _directive_title_overflow = _resolveDirective("title-overflow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DetailsHeaderPEL, null, {
      fullName: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("h2", {
          class: "applicant-name fullname-wrap text-overflow-ellipsis",
          title: _unref(summary).primaryApplicantFullName
        }, [
          _createTextVNode(_toDisplayString(_unref(summary).primaryApplicantFullName), 1)
        ], 8, _hoisted_2)), [
          [_directive_title_overflow]
        ])
      ]),
      statusDropdown: _withCtx(() => [
        _createVNode(ApplicationStatusContainer)
      ]),
      statusStepper: _withCtx(() => [
        _createVNode(DetailsStepper)
      ]),
      summary: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "label" }, "Credit Union Program", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives((_openBlock(), _createElementBlock("span", {
                      class: "lender-name",
                      title: lenderName.value
                    }, [
                      _createTextVNode(_toDisplayString(lenderName.value), 1)
                    ], 8, _hoisted_9)), [
                      [_directive_title_overflow]
                    ]),
                    _createElementVNode("span", _hoisted_10, " - " + _toDisplayString(productAbbreviation.value), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "label" }, "School", -1)),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "school-name",
                    title: _unref(summary).schoolName
                  }, [
                    _createTextVNode(_toDisplayString(_unref(summary).schoolName), 1)
                  ], 8, _hoisted_13)), [
                    [_directive_title_overflow]
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryFields.value, (field, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "summary-item",
                  key: index,
                  style: {}
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(field.title), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(field.value), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryFields.value, (field, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "summary-item",
                  key: index,
                  style: {}
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(field.title), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(field.value), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})